var cibBandcamp = ["32 32", "<path d='M0 25l9.917-18h22.083l-9.917 18z'/>"];

export { cibBandcamp };
